import { render, staticRenderFns } from "./StudentTestList.vue?vue&type=template&id=1f4c6c63"
import script from "./StudentTestList.vue?vue&type=script&lang=js"
export * from "./StudentTestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports